import { Input } from '@/components/ui/input';
import { useSearchingStore } from '../../../store/useSearchStore';
import { useDebounce } from '@/hooks/useDebounce';
import { Checkbox } from '@/components/Checkbox';

export const Filters = () => {
  const { searchPage, filters, handleToggleFilter, updateFilters, fixedTypes } = useSearchingStore();
  const { value: searchTerm, onChangeValue: onChangeSearchTerm } = useDebounce(
    (text) => updateFilters({ ...filters, searchTerm: text }),
    500,
    filters.searchTerm,
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="mt-4 flex flex-col gap-4">
        <Input
          label={`Search`}
          placeholder={'Type to search'}
          value={searchTerm}
          onChange={(e) => onChangeSearchTerm(e.target.value)}
          className="w-full"
          showSearchIcon
        />
      </div>
      <div>
        <p className="mb-2 font-cadiz text-sh-xs font-bold">Key Stage</p>
        <div className="flex max-w-[700px] flex-wrap">
          {searchPage?.searchPage?.keysStage?.map((keyStageItem) => {
            const keyStage = keyStageItem?.keyStage;
            if (!keyStage) return null;
            return (
              <Checkbox
                key={keyStage}
                checked={filters.keyStages?.includes(keyStage) || false}
                onCheckedChange={() => handleToggleFilter('keyStages', keyStage)}
                label={keyStage}
              />
            );
          })}
        </div>
      </div>
      <div>
        <p className="mb-2 font-cadiz text-sh-xs font-bold">Character Trait</p>
        <div className="flex max-w-[700px] flex-wrap">
          {searchPage?.searchPage?.traits?.map((traitItem) => {
            const trait = traitItem?.trait;
            if (!trait) return null;
            return (
              <Checkbox
                key={trait}
                checked={filters.traits?.includes(trait) || false}
                onCheckedChange={() => handleToggleFilter('traits', trait)}
                label={trait}
              />
            );
          })}
        </div>
      </div>
      <div>
        <p className="mb-2 font-cadiz text-sh-xs font-bold">Content Type</p>
        <div className="flex max-w-[700px] flex-wrap">
          {fixedTypes?.map((type) => {
            return (
              <Checkbox
                key={type}
                checked={filters.contentTypes?.includes(type) || false}
                onCheckedChange={() => handleToggleFilter('contentTypes', type)}
                label={type}
              />
            );
          })}
          {searchPage?.resourceTypes?.map(({ type }) => (
            <Checkbox
              key={type}
              checked={filters.contentTypes?.includes(type) || false}
              onCheckedChange={() => handleToggleFilter('contentTypes', type)}
              label={type}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
